import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API, ax, card, btn, inp, ImageUploadZone } from './adminHelpers';

export default function BoothsTab() {
  const [booths, setBooths] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ title: '', badge: '', desc: '', icon: '', base_price: '', features: [], active: true });
  const [featInput, setFeatInput] = useState('');
  const [file, setFile] = useState(null);

  const load = () => ax().get(`${API}/api/admin/booths`).then(r => setBooths(r.data.booths)).catch(() => {});
  useEffect(() => { load(); }, []);

  const save = async () => {
    const fd = new FormData();
    fd.append('title', form.title);
    fd.append('badge', form.badge);
    fd.append('desc', form.desc);
    fd.append('icon', form.icon);
    fd.append('base_price', form.base_price || 0);
    fd.append('active', form.active);
    fd.append('features', JSON.stringify(form.features));
    if (file) fd.append('image', file);

    if (editing) {
      await axios.patch(`${API}/api/admin/booths/${editing}`, fd, { withCredentials: true });
    } else {
      await axios.post(`${API}/api/admin/booths`, fd, { withCredentials: true });
    }
    setEditing(null);
    setForm({ title: '', badge: '', desc: '', icon: '', base_price: '', features: [], active: true });
    setFile(null);
    load();
  };

  const toggle = async (b) => { await ax().patch(`${API}/api/admin/booths/${b.id}`, { active: !b.active }); load(); };
  const parseFeatures = (f) => Array.isArray(f) ? f : (typeof f === 'string' ? JSON.parse(f || '[]') : []);

  const edit = (b) => {
    setEditing(b.id);
    setForm({ title: b.title, badge: b.badge || '', desc: b.desc || '', icon: b.icon || '', base_price: b.base_price || '', features: parseFeatures(b.features), active: b.active });
    setFile(null);
  };
  const del = async (id) => { if (window.confirm('Delete booth?')) { await ax().delete(`${API}/api/admin/booths/${id}`); load(); } };
  const addFeat = () => { if (featInput.trim()) { setForm(f => ({ ...f, features: [...f.features, featInput.trim()] })); setFeatInput(''); } };
  const remFeat = (i) => setForm(f => ({ ...f, features: f.features.filter((_, j) => j !== i) }));

  return (
    <div>
      <div style={card}>
        <h3 style={{ margin: '0 0 16px', color: '#9F5CFF', fontSize: 15 }}>{editing ? 'Edit Booth Type' : 'Add Booth Type'}</h3>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10, marginBottom: 10 }}>
          <input placeholder="Booth Title (e.g. Glam Booth)" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} style={inp(false)} />
          <input placeholder="Base Price for 2 hrs ($)" type="number" value={form.base_price} onChange={e => setForm({ ...form, base_price: e.target.value })} style={inp(false)} />
          <input placeholder="Badge (e.g. Crowd Magnet)" value={form.badge} onChange={e => setForm({ ...form, badge: e.target.value })} style={inp(false)} />
        </div>

        <textarea placeholder="Description" value={form.desc} onChange={e => setForm({ ...form, desc: e.target.value })}
          style={{ ...inp(false), height: 80, resize: 'vertical', fontFamily: 'inherit', marginBottom: 10 }} />

        <div style={{ display: 'flex', gap: 10, marginBottom: 16 }}>
          <input placeholder="Icon Emoji (e.g. 🎥)" value={form.icon} onChange={e => setForm({ ...form, icon: e.target.value })}
            style={{ ...inp(false), width: 160 }} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#a0a0b8', fontSize: 13 }}>
            <input type="checkbox" checked={form.active} onChange={e => setForm({ ...form, active: e.target.checked })} /> Active on site
          </label>
        </div>

        <ImageUploadZone label="Booth Display Image" file={file} onChange={e => setFile(e.target.files[0])} />

        <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
          <input placeholder="Add feature (e.g. Slow-mo videos)…" value={featInput}
            onChange={e => setFeatInput(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && addFeat()}
            style={{ ...inp(false), flex: 1 }} />
          <button onClick={addFeat} style={btn('#9F5CFF')}>+ Add Feature</button>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 20 }}>
          {form.features.map((f, i) => (
            <span key={i} onClick={() => remFeat(i)}
              style={{ background: 'rgba(159,92,255,0.12)', color: '#9F5CFF', fontSize: 12, padding: '4px 10px', borderRadius: 50, border: '1px solid rgba(159,92,255,0.3)', cursor: 'pointer' }}>
              {f} ✕
            </span>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={save} style={btn('#9F5CFF')}>💾 Save Booth</button>
          {editing && (
            <button onClick={() => { setEditing(null); setForm({ title: '', badge: '', desc: '', icon: '', base_price: '', features: [], active: true }); setFile(null); }} style={btn('#555', true)}>
              Cancel
            </button>
          )}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: 14 }}>
        {booths.map(b => (
          <div key={b.id} style={{ ...card, opacity: b.active ? 1 : 0.6, padding: 0, overflow: 'hidden' }}>
            {b.image_url
              ? <img src={b.image_url} alt={b.title} style={{ width: '100%', height: 140, objectFit: 'cover' }} />
              : <div style={{ width: '100%', height: 140, background: 'rgba(255,255,255,0.04)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <span style={{ fontSize: 36, opacity: 0.5 }}>{b.icon || '📸'}</span>
                </div>
            }
            <div style={{ padding: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, margin: '0 0 4px' }}>
                <p style={{ margin: 0, fontSize: 15, color: '#fff', fontWeight: 700 }}>{b.icon} {b.title}</p>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                  <span style={{ fontSize: 13, color: '#27C85A', fontWeight: 600 }}>${parseFloat(b.base_price || 0).toFixed(2)} (2h)</span>
                </div>
              </div>
              {b.badge && <span style={{ fontSize: 11, background: '#9F5CFF', color: '#fff', padding: '2px 6px', borderRadius: 4, fontWeight: 700 }}>{b.badge}</span>}
              <p style={{ margin: '6px 0 12px', fontSize: 12, color: '#a0a0b8' }}>{b.desc}</p>
              <div style={{ display: 'flex', gap: 6 }}>
                <button onClick={() => toggle(b)} style={btn(b.active ? '#27C85A' : '#555', true)}>{b.active ? 'Active' : 'Hidden'}</button>
                <button onClick={() => edit(b)} style={btn('#9F5CFF', true)}>Edit</button>
                <button onClick={() => del(b.id)} style={btn('#E34364', true)}>Delete</button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
